import { ArticleCard, type ArticleCardData } from './ArticleCard';

export function HighlightsSection({ items }: { items: ArticleCardData[] }) {
  if (items.length === 0) return null;
  return (
    <section className="highlights-area pt-5">
      <div className="container">
        <div className="row">
          {items.map((it) => (
            <div className="col-lg-4 col-md-4" key={it.id}>
              <ArticleCard card={it} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
